<template>
  <v-dialog v-model="open" persistent max-width="600px">
    <material-card color="primary" :title="title" :text="item.name">
      <v-form ref="form" v-model="validForm">
        <v-container grid-list-md>
          <v-layout wrap>
            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                md4
                v-model="item.sponsor_id"
                :items="sponsors"
                label="Sponsor"
                :rules="validators.protocol.sponsor"
                item-value="id"
                item-text="name"
                readonly
                disabled
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="Name"
                :disabled="false"
                v-model="item.name"
                :rules="validators.protocol.name"
                readonly
              ></v-text-field>
            </v-flex>

            <!-- issue 668 , messo :disabled="true" invece di :disabled="false"  -->
            <v-flex xs12 sm6 md6>
              <v-select
                clearable
                label="Provider"
                :disabled="true" 
                v-model="item.provider"
                :items="providers"
                :rules="validators.protocol.provider"
                readonly
              ></v-select>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-text-field
                label="External Name"
                :disabled="false"
                v-model="item.map_name"
                :rules="validators.protocol.external_name"
                readonly
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-combobox
                multiple
                v-model="item.arms_r1"
                label="Arms Random1"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent
                readonly
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-combobox
                multiple
                v-model="item.arms_r2"
                label="Arms Random2"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent
                readonly
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-combobox
                multiple
                v-model="item.arms_r3"
                label="Arms Random3"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent
                readonly
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-combobox
                multiple
                v-model="item.arms_r4"
                label="Arms Random4"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent
                readonly
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm6 md6>
              <v-combobox
                multiple
                v-model="item.co_sponsors"
                label="Co Sponsors"
                append-icon
                chips
                deletable-chips
                class="tag-input"
                @keydown.space.prevent
                readonly
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-combobox
                multiple
                v-model="item.actions_taken"
                label="Actions taken"
                _append-icon
                chips
                deletable-chips
                class="tag-input"
                append-outer-icon="mdi-import"
                @click:append-outer="setDefaultActionsTaken"
                @keydown.space.prevent
                :readonly="!$can('upsert', 'protocol')"
              >
              </v-combobox>
            </v-flex>

            <v-flex xs12 sm12 md12>
              <v-select
                clearable
                md4
                v-model="item.status"
                :items="['Open', 'Draft', 'Closed']"
                label="Status"
                :rules="validators.required"
                readonly
                disabled
              ></v-select>
            </v-flex>
          </v-layout>
        </v-container>
      </v-form>

      <v-flex xs12 text-xs-right>
        <v-btn class="mx-1 font-weight-light" color="success" @click="close()"
          >Close</v-btn
        >

        <v-btn
          v-if="$can('upsert', 'protocol')"
          class="mx-1 font-weight-light"
          color="purple"
          :disabled="!checkSave() && !validForm"
          @click="save()"
          >Save</v-btn
        >
      </v-flex>
    </material-card>
  </v-dialog>
</template>

<script>
import { upsert, getDetail } from "@/api/protocol";
import validators from "@/utils/validators";

export default {
  inheritAttrs: false,
  data() {
    return {
      validForm: true,
      providers: [
        "REDCap",
        "Emntg",
        "MM-sen",
        "RealMM",
        "Medidata",
        "Opis",
        "Heads",
      ],
      validators,
    };
  },
  mounted() {},
  watch: {
    open() {
      if (this.isNew) {
        this.$refs.form.resetValidation();
        this.item.sponsor_id = this.$store.getters.sponsor_id;
      }
    },
  },
  computed: {
    open() {
      return this.$store.getters.protocolDialog;
    },
    item: {
      get() {
        return this.$store.getters.protocolItem;
      },
      set(v) {},
    },
    sponsors() {
      return this.$store.getters.sponsors;
    },
    isNew() {
      return this.item.id ? false : true;
    },
    title() {
      return this.isNew ? "New Protocol" : "Protocol details";
    },
  },
  methods: {
    getData() {
      return getDetail(this.item.id, this.projectId).then((data) => {
        const newItem = JSON.parse(JSON.stringify(data).replace('""', /null/i));
        this.$store.commit("app/protocolItem", newItem);
      });
    },
    close() {
      this.$store.dispatch("app/closeProtocolDialog");
    },
    checkSave() {
      return !this.isNew;
    },
    setDefaultActionsTaken() {
      this.item.actions_taken = [
        "Dose not changed",
        "Dose reduced",
        "Drug suspended",
        "Procedure suspended",
        "Drug withdrawn",
        "Procedure withdrawn",
        "Unknown",
        "Not applicable",
        "None",
      ];
    },
    save() {
      if (!this.$refs.form.validate()) {
        this.$store.dispatch("app/openSnackbar", {
          message: "Please fix validation errors!",
          color: "error",
        });
        return;
      }

      upsert(this.item)
        .then((data) => {
          this.$store.dispatch("app/openSnackbar", {
            message: "Protocol updated correctly",
            color: "success",
          });
          const newItem = JSON.parse(JSON.stringify(data.data));
          this.$store.commit("app/protocolItem", newItem);
          this.$root.$emit("updateProtocols", newItem);
        })
        .catch((e) => {
          this.$store.dispatch("app/openSnackbar", {
            message:
              "An Error occurred during the Protocol update. " +
              e.response.data.message,
            color: "error",
          });
        });
    },
  },
};
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
